import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles/Footer.module.scss';
import Button from '../Common/Button';

const Footer = () => {
  const { t } = useTranslation();

  const hideLummeInfoAfterOomi = new Date() >= new Date('2026-01-01T00:00:00Z');

  return (
    <>
      <footer className={styles.footer}>
        <div className={styles.container}>
          <div className={styles.top}>
            <div className={styles.socialMedia}>
              {!hideLummeInfoAfterOomi && (
                <>
                  <h2>{t('common:footer.followUs')}</h2>
                  <div className={styles.socialMediaButtons}>
                    <a className={styles.facebook} href="https://www.facebook.com/LummeEnergia" target="_blank" rel="noopener noreferrer">
                      Facebook
                    </a>
                    <a className={styles.instagram} href="https://www.instagram.com/lummeenergia/" target="_blank" rel="noopener noreferrer">
                      Instagram
                    </a>
                    <a className={styles.linkedin} href="https://www.linkedin.com/company/lummeenergia" target="_blank" rel="noopener noreferrer">
                      LinkedIn
                    </a>
                  </div>
                </>
              )}
            </div>
            <Button link="https://www.lumme-energia.fi/ota-yhteytta" newTab>
              {t('common:footer.contactButton')}
            </Button>
          </div>
          <div className={styles.bottom}>
            {!hideLummeInfoAfterOomi && (
              <div className={styles.company}>
                <h2>{t('common:footer.companyName')}</h2>
                <p>{t('common:footer.addressLine1')}</p>
                <p>{t('common:footer.addressLine2')}</p>
                <p>{t('common:footer.businessId')}</p>
              </div>
            )}
            <nav className={`${styles.links} ${hideLummeInfoAfterOomi ? styles.oomiLinks : ''}`} aria-label="Footer">
              <ul>
                <li>
                  <a href="https://www.lumme-energia.fi/aurinkopaneelit" target="_blank" rel="noopener noreferrer">
                    {t('common:footer.solarPanels')}
                  </a>
                </li>
                <li>
                  <a href="https://www.lumme-energia.fi/sahkoauton-lataus" target="_blank" rel="noopener noreferrer">
                    {t('common:footer.evCharging')}
                  </a>
                </li>
                <li>
                  <a href="https://www.lumme-energia.fi/sahkosopimus" target="_blank" rel="noopener noreferrer">
                    {t('common:footer.contracts')}
                  </a>
                </li>
                <li>
                  <a href="https://www.lumme-energia.fi/yrityksille/yrityssahko" target="_blank" rel="noopener noreferrer">
                    {t('common:footer.b2bContracts')}
                  </a>
                </li>
                <li>
                  <a href="https://www.lumme-energia.fi/sahkosopimus/sopimusehdot" target="_blank" rel="noopener noreferrer">
                    {t('common:footer.contractTerms')}
                  </a>
                </li>
                <li>
                  <a href="https://www.lumme-energia.fi/sahkosopimus/porssisahko/hinta" target="_blank" rel="noopener noreferrer">
                    {t('common:footer.spotPricing')}
                  </a>
                </li>
                <li>
                  {/* Works only in production */}
                  <a
                    onClick={() => {
                      // @ts-ignore
                      const _hsp = (window._hsp = window._hsp || []);
                      _hsp.push(['showBanner']);
                    }}
                  >
                    {t('common:footer.cookieSettings')}
                  </a>
                </li>
                <li>
                  <a href="https://www.lumme-energia.fi/yhteystiedot#henkilot" target="_blank" rel="noopener noreferrer">
                    {t('common:footer.employeesContactInfo')}
                  </a>
                </li>
                <li>
                  <a href="https://www.lumme-energia.fi/yhteystiedot#laskutustiedot" target="_blank" rel="noopener noreferrer">
                    {t('common:footer.billingInfo')}
                  </a>
                </li>
                <li>
                  <a href="https://www.lumme-energia.fi/sopimuksen-peruutus" target="_blank" rel="noopener noreferrer">
                    {t('common:footer.contractCancellation')}
                  </a>
                </li>
                <li>
                  <a href="https://www.lumme-energia.fi/tietosuojaseloste" target="_blank" rel="noopener noreferrer">
                    {t('common:footer.privacy')}
                  </a>
                </li>
                <li>
                  <a href="https://www.lumme-energia.fi/saavutettavuusseloste/omalumme" target="_blank" rel="noopener noreferrer">
                    <strong>{t('common:footer.accessibilityLink')}</strong>
                  </a>
                </li>
                <li>
                  <a
                    href={
                      hideLummeInfoAfterOomi
                        ? 'https://oomi-whistleblow.granitegrc.com/'
                        : 'https://www.lumme-energia.fi/vaarinkaytosten-ilmoituskanava'
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t('common:footer.whistleBlower')}
                  </a>
                </li>
              </ul>
            </nav>
            <div className={styles.message}>
              <Button link="https://www.lumme-energia.fi/ota-yhteytta" newTab>
                {t('common:footer.contactButton')}
              </Button>
              {!hideLummeInfoAfterOomi && t('common:footer.message')}
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
